import _slicedToArray from "/Users/lianzhaocheng/Downloads/workplace/bieyang/web/bybieyang-home/product-search/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from 'react';
import { mergeProps } from '../../utils/with-default-props';
import { RadioGroupContext } from './group-context';
import { usePropsValue } from '../../utils/use-props-value';
var defaultProps = {
  disabled: false,
  defaultValue: null
};
export var Group = function Group(p) {
  var props = mergeProps(defaultProps, p);

  var _usePropsValue = usePropsValue({
    value: props.value,
    defaultValue: props.defaultValue,
    onChange: function onChange(v) {
      var _a;

      if (v === null) return;
      (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, v);
    }
  }),
      _usePropsValue2 = _slicedToArray(_usePropsValue, 2),
      value = _usePropsValue2[0],
      setValue = _usePropsValue2[1];

  return React.createElement(RadioGroupContext.Provider // TODO: 性能优化
  , {
    // TODO: 性能优化
    value: {
      value: value === null ? [] : [value],
      check: function check(v) {
        setValue(v);
      },
      uncheck: function uncheck() {},
      disabled: props.disabled
    }
  }, props.children);
};